import { render, staticRenderFns } from "./VendorDoc.vue?vue&type=template&id=45e239a8&"
import script from "./VendorDoc.vue?vue&type=script&lang=js&"
export * from "./VendorDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45e239a8')) {
      api.createRecord('45e239a8', component.options)
    } else {
      api.reload('45e239a8', component.options)
    }
    module.hot.accept("./VendorDoc.vue?vue&type=template&id=45e239a8&", function () {
      api.rerender('45e239a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/vendor-partners/modals/VendorDoc.vue"
export default component.exports